<template>
  <HKLInput
    v-bind="$attrs"
    v-model="proxyValue"
    v-fusioninputcheck="checkerObject"
    v-on="$listeners"
  />
</template>

<script>
import { computed } from 'vue-demi'
import i18n from '@/utils/i18n'
import HKLInput from './HKLInput.vue'
import { validateEmails } from './HKLInputEmails.service'

export const SOURCE = 'value'
export const EVENT = '_change'

export default {
  components: {
    HKLInput,
  },
  model: {
    prop: SOURCE,
    event: EVENT,
  },
  props: {
    [SOURCE]: {
      type: String,
      default: () => '',
      required: true,
    },
    checkerOptions: {
      type: Object,
      default: () => ({}),
    },
    separator: {
      type: String,
      default: () => ';',
      validator: (val) => val.length,
    },
  },
  setup (props, { emit }) {
    const checkerObject = computed(() => {
      return Object.assign({
        type: 'string',
        tip: i18n.t('hint.inputTip.email'),
        pattern: validateEmails(props.separator),
        classes: 'tooltip-class',
        required: props[SOURCE].trim(),
      }, typeof props.checkerOptions === 'object' && props.checkerOptions)
    })
    const proxyValue = computed({
      get () { return props[SOURCE] },
      set (newValue) {
        emit(EVENT, newValue)
      },
    })

    return {
      proxyValue,
      checkerObject,
    }
  },
}
</script>
